// extracted by mini-css-extract-plugin
module.exports = {"navsContainer":"styles_navsContainer__qaDP2"};